import React from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';

import Icon from '@component/icon';
import Button from '@component/form/element/button';

import { OSLO_GRAY } from '@constant/colors';

const PanelTopBar = ({
  returnPath,
  returnName,
  onCloseClick,
  onBackClick,
  onKeyDown,
}) => {
  const basePanelTopBar = (
    <div className="panel__topbar">
      <Button
        className="panel__close"
        onClick={onCloseClick}
        onKeyDown={onKeyDown}
        icon={
          <Icon
            hoverColor={OSLO_GRAY}
            type="Close"
            label={I18n.t('panel.close')}
          />
        }
      />
    </div>
  );

  if (!returnPath) {
    return basePanelTopBar;
  }

  if (!returnName) {
    return <a href={returnPath}>{basePanelTopBar}</a>;
  }

  return (
    <div className="panel__topbar">
      <a href={returnPath} className="panel__back" onClick={onBackClick}>
        <Icon
          className="panel__back-icon"
          hoverColor={OSLO_GRAY}
          type="ArrowCircle"
        />
        <span className="panel__back-text">
          {I18n.t('panel.return_to', { pageName: returnName })}
        </span>
      </a>
    </div>
  );
};

PanelTopBar.propTypes = {
  returnPath: PropTypes.string,
  returnName: PropTypes.string,
  onCloseClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  onBackClick: PropTypes.func,
};

export default React.memo(PanelTopBar);
